// ThankYou.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ThankYou() {
  const { state } = useLocation();
  const navigate = useNavigate();

  // Try router state first; otherwise try localStorage fallback
  const fallback = (() => {
    try {
      const raw = localStorage.getItem("lastDonationReceipt");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  })();

  const receipt = state && state.receiptURL ? state : (fallback || null);

  const openReceipt = () => {
    if (receipt && receipt.receiptURL) {
      window.open(receipt.receiptURL, "_blank");
    } else {
      alert("Receipt not available.");
    }
  };

  const copyReceipt = async () => {
    if (receipt && receipt.receiptURL) {
      try {
        await navigator.clipboard.writeText(receipt.receiptURL);
        alert("Receipt URL copied to clipboard");
      } catch (e) {
        alert("Copy failed. Receipt URL: " + receipt.receiptURL);
      }
    } else {
      alert("Receipt not available.");
    }
  };

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
      <h1>Thank you for your donation 🙏</h1>

      {receipt ? (
        <div style={{ marginTop: 20, border: "1px solid #eee", padding: 16, borderRadius: 8 }}>
          <p><strong>Amount:</strong> ₹{receipt.amount || "N/A"}</p>
          <p><strong>Donor:</strong> {(receipt.donor && receipt.donor.name) || "N/A"}</p>
          <p><strong>Mobile:</strong> {(receipt.donor && receipt.donor.phone) || "N/A"}</p>
          <p><strong>Receipt no:</strong> {receipt.rno || "N/A"} <span style={{ marginLeft: 10 }}><strong>RB:</strong> {receipt.rbno || "N/A"}</span></p>

          <div style={{ marginTop: 12, display: "flex", gap: 10 }}>
            <button onClick={openReceipt} style={{ padding: "10px 14px", background: "#0b74de", color: "#fff", border: "none", borderRadius: 6 }}>Open Receipt</button>
            <button onClick={copyReceipt} style={{ padding: "10px 14px", background: "#2d7a2d", color: "#fff", border: "none", borderRadius: 6 }}>Copy Link</button>
            <button onClick={() => navigate("/")} style={{ padding: "10px 14px", background: "#666", color: "#fff", border: "none", borderRadius: 6 }}>Back to Home</button>
          </div>
        </div>
      ) : (
        <div style={{ marginTop: 20 }}>
          <p>We couldn't find a receipt for this donation right now. If you completed payment, our team will follow up and send the receipt to your number/email.</p>
          <div style={{ marginTop: 12 }}>
            <button onClick={() => navigate("/")} style={{ padding: "10px 14px", background: "#666", color: "#fff", border: "none", borderRadius: 6 }}>Back to Home</button>
          </div>
        </div>
      )}
    </div>
  );
}
